import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import VideoEditor from '../VideoEditor/VideoEditor';
import CaptionEditor from '../CaptionEditor/CaptionEditor';

const SmartEditor: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Check URL parameters to determine which editor to use
  const hasVideoUrl = searchParams.get('video-url');
  const hasAudioUrl = searchParams.get('audio-url');
  
  // Redirect old URLs: if we're on /caption route with audio-url, redirect to /create-content
  useEffect(() => {
    if (hasAudioUrl && window.location.pathname === '/caption') {
      // Preserve all search parameters and redirect to create-content
      const currentSearch = window.location.search;
      navigate(`/create-content${currentSearch}`, { replace: true });
      return;
    }
  }, [hasAudioUrl, navigate]);
  
  // If video-url is present (caption workflow), use CaptionEditor
  if (hasVideoUrl && !hasAudioUrl) {
    return <CaptionEditor />;
  }
  
  // If audio-url is present, this should have been redirected to /create-content
  // This is just a fallback in case the redirect didn't work
  if (hasAudioUrl) {
    return <VideoEditor />;
  }
  
  // Default to CaptionEditor for /caption route
  return <CaptionEditor />;
};

export default SmartEditor;
